import { NumberInput } from '@mantine/core';
import { isString } from 'lodash/fp';
import React, { FC } from 'react';

import { FieldRendererProps } from '@portals/types';

const NumberField: FC<FieldRendererProps> = ({
  error,
  field,
  value,
  handleBlur,
  setFieldValue,
  readOnly,
  disabled,
  required,
}) => {
  const { name, title, placeholder, inputProps } = field;
  const { startAdornment, endAdornment, ...restInputProps } = inputProps || {};

  return (
    <NumberInput
      error={error}
      data-testid={'number-input-' + name}
      icon={startAdornment}
      rightSection={endAdornment}
      label={title}
      name={name}
      required={required}
      placeholder={placeholder || (isString(title) ? title : '')}
      value={value}
      disabled={disabled || readOnly}
      onChange={(value) => setFieldValue(field.name, value)}
      onBlur={handleBlur}
      min={0}
      {...restInputProps}
    />
  );
};

export default NumberField;
